import { render, staticRenderFns } from "./WizardHorarioAgenda.vue?vue&type=template&id=c74aa6ba&"
import script from "./WizardHorarioAgenda.vue?vue&type=script&lang=js&"
export * from "./WizardHorarioAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports